<template>
  <section class="list">
    <div v-if="loading" class="loading-wrapper">
      <p class="loading-text">Cargando modos...</p>
    </div>
    <div v-else class="row">
      <article
        class="card mode-card"
        v-for="mode in modes"
        :key="mode.code"
        @click="selectMode(mode)"
      >
        <div class="icon-wrapper">
          <img
            v-if="mode.photo_url"
            :src="getImageUrl(mode.photo_url)"
            class="card-image"
            :alt="mode.name"
            @error="$event.target.style.display = 'none'"
          />
        </div>
        <h3>{{ mode.name }}</h3>
        <p v-if="mode.description" class="description">
          {{ mode.description }}
        </p>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "SelectProductionMode",

  props: {
    finca: {
      type: Object,
      required: true,
    },
    zona: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      modes: [],
      loading: false,
    };
  },

  mounted() {
    this.fetchModes();
  },

  watch: {
    zona() {
      this.fetchModes();
    },
    finca() {
      this.fetchModes();
    },
  },

  methods: {
    getImageUrl(photoUrl) {
      if (!photoUrl) {
        return null;
      }

      const normalizedUrl = String(photoUrl).trim();
      if (
        normalizedUrl.startsWith("data:") ||
        normalizedUrl.startsWith("blob:")
      ) {
        return normalizedUrl;
      }

      if (
        normalizedUrl.startsWith("http://") ||
        normalizedUrl.startsWith("https://")
      ) {
        try {
          const parsedUrl = new URL(normalizedUrl);
          if (
            ["localhost", "127.0.0.1", "0.0.0.0"].includes(
              parsedUrl.hostname,
            ) ||
            parsedUrl.hostname.startsWith("10.0.2.")
          ) {
            return `${this.$hostname}${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
          }
          if (parsedUrl.protocol === "http:") {
            parsedUrl.protocol = "https:";
          }
          return parsedUrl.toString();
        } catch {
          return normalizedUrl.replace(/^http:\/\//i, "https://");
        }
      }

      const path = normalizedUrl.startsWith("/")
        ? normalizedUrl
        : `/${normalizedUrl.replace(/^\/+/, "")}`;
      return `${this.$hostname}${path}`;
    },

    async fetchModes() {
      this.loading = true;
      try {
        let params = "";
        if (this.zona?.id) {
          params = `?zone=${this.zona.id}`;
        } else if (this.finca?.id) {
          // For commercial farmlands without zones, pass farmland_id
          params = `?farmland_id=${this.finca.id}`;
        }
        const response = await this.$http.get(
          `${this.$hostname}/modes/${params}`,
        );
        this.modes = response.data;

        // Auto-select if only one mode available (e.g., COUNT for commercial farmlands)
        if (this.modes.length === 1) {
          this.$nextTick(() => this.selectMode(this.modes[0]));
        }
      } catch (e) {
        console.error("Error al cargar modos de producción:", e);
        this.modes = [];
      } finally {
        this.loading = false;
      }
    },

    selectMode(mode) {
      console.log(`Modo seleccionado: ${mode.code}`);
      this.$root.$emit("production-mode", mode);
    },
  },
};
</script>

<style scoped>
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
}

.loading-text {
  color: #666;
  font-size: 0.95em;
}

.mode-card {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.mode-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.mode-card:active {
  transform: translateY(-2px);
}

.description {
  font-size: 0.85em;
  color: #666;
  margin-top: 8px;
  padding: 0 10px;
  text-align: center;
}

.icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
